<template>
  <div v-if="modifiedSalesDocument" class="p-4" :class="isHorizontalLayout ? 'w-1/2' : ' w-5/6'">
    <label
      for="remarks"
      class="block w-full text-sm font-semibold leading-6 text-gray-800 sm:w-auto"
      >{{ $t('material.remarks') }}
    </label>
    <textarea
      name="remarks"
      id="remarks"
      :disabled="mode === 'view'"
      v-model="modifiedSalesDocument.documentHeader.remarks"
      rows="10"
      class="block w-full px-3 py-3 text-gray-700 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-theme-400 focus:ring-inset sm:text-sm sm:leading-6 focus-visible:outline-none"></textarea>
  </div>
</template>

<script setup lang="ts">
import { useSalesDocumentsStore } from '@/stores/salesDocuments';
import { storeToRefs } from 'pinia';

defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout?: boolean;
}>();

const { modifiedSalesDocument } = storeToRefs(useSalesDocumentsStore());
</script>
